import React, { useEffect, Fragment, useContext, useState } from 'react';
import { UL, LI, Btn } from '../../../../AbstractElements';
import { Col, Card, CardBody, Media } from 'reactstrap';
import user from '../../../../assets/images/user/1.jpg';
import { Link } from 'react-router-dom';
import { pinagareAPIURL,MARKJENCO, MARKJENCOEMAIL, NEWMAIL, Inbox, AllMail, Sent, Draft, Trash, IMPORTANT, Starred, UNREAD, Spam, OUTBOX, UPDATE, ALERT, NOTES } from '../../../../Constant';
import EmailContext from '../../../../_helper/Email';
import CustomizerContext from '../../../../_helper/Customizer';


const Email = () => {
  const { allEmails, types, setType, type, getAllType, groupBy, setCompose, isDataIn, setIsDataIn, pinagareFetchRequestas } = useContext(EmailContext);
  const TypesOfData = types;
  const { layoutURL } = useContext(CustomizerContext);
  const [isOpen, setIsOpen] = useState(false);
  
  useEffect(() => {
    if (allEmails !== null) {
      const result = groupBy(allEmails, (item) => {
        return [item.type];
      });
      getAllType(result);
    }

    if(!isDataIn){
    const body_x=JSON.stringify({
              
      omang:localStorage.getItem('username'),
      eng:'fetch_pinagare_user_applications',       
      
    });

    pinagareFetchRequestas(pinagareAPIURL,body_x,'fetch_pinagare_user_applications');
    }

    //setIsDataIn(isDataIn);

  }, [allEmails,isDataIn]);

  const clickCompose = () => {
    setCompose(true);
  };

  const selectTypes = (types) => {
    setType(types);
  };

  return (
    <Fragment>
      <Col xl='3' md='6 box-col-6'>
        <div className='md-sidebar'>
          {/*<Btn attrBtn={{ onClick: (e) => setIsOpen(!isOpen), color: 'primary', className: 'md-sidebar-toggle' }}>email filter{'iiii'}</Btn>*/}
          <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen && 'open'} `}>
            <div className='email-left-aside'>
              <div className='email-left-aside'>
                <Card>
                  <CardBody>
                    <div className='email-app-sidebar'>
                      <Media className='align-items-center'>
                        
                        <Media body>
                         
                            <h6 className='f-w-600'>{"APPLICATIONS CENTER"}</h6>
                          
                          <p className='align-items-center' style={{paddingLeft:'50px'}}>{"All Applications"}</p>
                        </Media>
                      </Media>
					  <hr />
                      <UL attrUL={{ className: 'nav main-menu flex-row', role: 'tablist' }}>
                        
                        <LI attrLI={{ className: 'nav-item border-0', onClick: () => selectTypes('Programmes') }}>
                          <a className={`show ${type === 'Programmes' ? 'active' : ''}`} href='#javascript'>
                            <span className='title'>
                              <i className='icon-file'></i>
                              {"PROGRAMMES"}
                            </span>
                            <span className='badge pull-right digits'>({TypesOfData['Programmes'] ? TypesOfData['Programmes'].length : 0})</span>
                          </a>
                        </LI>
                        <LI attrLI={{ className: 'nav-item border-0', onClick: () => selectTypes('Leave') }}>
                          <a className={`${type === 'Leave' ? 'active' : ''}`} href='#javascript'>
                            <span className='title'>
                              <i className='icon-folder'></i>
                              {"LEAVE"}
                            </span>
							<span className='badge pull-right digits'>({TypesOfData['Leave'] ? TypesOfData['Leave'].length : 0})</span>
                          </a>
                        </LI>
                        <LI attrLI={{ className: 'border-0', onClick: () => selectTypes('Vacancies') }}>
                          <a href='#javascript' className={`${type === 'Vacancies' ? 'active' : ''}`}>
                            <span className='title'>
                              <i className='icon-new-window'></i>
                              {"VACANCIES"}
                            </span>
                            <span className='badge pull-right digits'>({TypesOfData['Vacancies'] ? TypesOfData['Vacancies'].length : 0})</span>
                          </a>
                        </LI>
                        <LI attrLI={{ className: 'border-0', onClick: () => selectTypes('Benefits & Claims') }}>
                          <a href='#javascript' className={`${type === 'Benefits & Claims' ? 'active' : ''}`}>
                            <span className='title'>
                              <i className='icon-pencil-alt'></i>
                              {"BENEFITS & CLAIMS"}
                            </span>
                            <span className='badge pull-right digits'>({TypesOfData['Benefits & Claims'] ? TypesOfData['Benefits & Claims'].length : 0})</span>
                          </a>
                        </LI>
                        <LI attrLI={{ className: 'border-0', onClick: () => selectTypes('Training') }}>
                          <a href='#javascript' className={`${type === 'Training' ? 'active' : ''}`}>
                            <span className='title'>
                              <i className='icon-notepad'></i>
                              {"TRAINING"}
                            </span>
                            <span className='badge pull-right digits'>({TypesOfData['Training'] ? TypesOfData['Training'].length : 0})</span>
                          </a>
                        </LI>
                       
                        <LI attrLI={{ className: 'border-0' }}>
                          <hr />
                        </LI>
                        
                      </UL>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};
export default Email;
